import React from 'react'

const ComputerIcon = ({color = 'currentColor', width = 24, height = 24, ...rest}) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <g clipPath="url(#clip0_computer)">
            <path
                d="M20 18C21.1 18 21.99 17.1 21.99 16L22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V16C2 17.1 2.9 18 4 18H0V20H24V18H20ZM4 6H20V16H4V6Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_computer">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

export default ComputerIcon
